export const blogsQueryKeys = {
  list: (lang) => ['blogs', 'list', lang],
  recent: (lang) => ['blogs', 'recent', lang],
  read: (slug, lang) => ['blogs', slug, lang]
};
